import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取礼品卡信息
Mock.mock(/gift_card\/query_for_write_off/, 'get' + mockSwitch, {
  'code': 0, // （0，成功，其他都是失败）
  'message': '成功信息',
  // 判断是否有coupon_batch.view的权限
  'data': {
    'gift_card_id': 1,
    'title': '全额保费返现卡', // 卡名称
    'card_no': '236867688', // 卡号
    'plate_number': '粤B12345', // 车牌号
    'face_value': 99000, // 面值，单位为分
    'balance': 1000.00, // 余额，单位为分
    'create_at': '2018-3-24', // 发卡时间，如 2018-04-18
    'expired_at': '2018-5-28', // 过期时间，如 2018-07-18
    'is_canceled': '@boolean()', // 卡是否已作废
    'is_expired': '@boolean()' // 卡是否已过期
  }
})

// 卡券核销
Mock.mock(/gift_card\/write_off/, 'post' + mockSwitch, {
  'code': 0, // （0，成功，其他都是失败）
  'message': '成功信息',
  // 判断是否有coupon_batch.view的权限
  'data': {
    'write_off_sum': '@integer()', // 核销成功的金额， 单位为分
    'biz_no': '@string("number", 12)' // 业务单号
  }
})

// 礼品卡发放/申请记录查询 按批次显示
Mock.mock(/gift_card\/card_issue_requests\/records/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'card_issue_requests|10': [{
      'applicant': '@word',
      'customer': '@word',
      'customer_mobile': '15914038584',
      'plate_number': '粤B88888',
      'reason': '@word',
      'submit_at': '2018-10-06 10:24:00',
      'status|3': [
        {
          'title': '礼品卡@word',
          'face_value': 11100,
          'num': 8,
          'status': 1,
          'submit_at': '2018-10-06 10:24:03',
          'progress': [
            {
              'review_at': '2018-10-06 10:45:21',
              'reviewers': ['邓轻松', 'Alfred'],
              'status': 1,
              'actual_reviewer': 'Alfred'
            },
            {
              'review_at': '2018-10-06 10:45:21',
              'reviewers': ['邓轻松', 'Alfred'],
              'status': 2,
              'actual_reviewer': 'Alfred'
            },
            {
              'review_at': '2018-10-06 10:45:21',
              'reviewers': ['邓轻松', 'Alfred'],
              'status': 3,
              'actual_reviewer': 'Alfred'
            },
            {
              'review_at': '2018-10-06 10:45:21',
              'reviewers': ['邓轻松', 'Alfred'],
              'status': 4,
              'actual_reviewer': 'Alfred'
            }
          ]
        }
      ]
    }],
    'total_num': 22
  }
})

// 审核通过、不通过
Mock.mock(/gift_card\/card_issue_requests\/(reject|pass)/, 'patch' + mockSwitch, {
  'code': 0, // （0，成功，其他都是失败）
  'message': '成功信息',
  'data': null
})

// 退回通过、不通过
Mock.mock(/gift_card\/card_issue_requests\/(pass|reject)/, 'patch' + mockSwitch, {
  'code': 0, // （0，成功，其他都是失败）
  'message': '成功信息',
  'data': null
})

// 获取退回申请信息
Mock.mock(/gift_card\/retreat_requests\/\d$/, 'get' + mockSwitch, {
  'code': 0, // （0，成功，其他都是失败）
  'message': '成功信息',
  'data': {
    'retreat_request_id': '@string("number", 2)', // 退回申请id
    'requestor': '@cname()', // 申请人姓名
    'to_customer_name': '@cname()', // 发放客户姓名
    'to_customer_mobile': '@string("number", 11)', // 发放客户手机
    'to_customer_plate_number': '粤B12345', // 发放客户车牌号
    'create_at': '@date("yyyy-MM-dd HH:mm:ss")', // 提交时间，如 2018-04-18 15:33:32
    'gift_card_no': '@string("number", 2)', // 礼品卡号
    'gift_card_title': '@cword(10)', // 礼品卡名称
    'gift_card_face_value': '@integer(500, 10000)', // 礼品卡面值，单位为分
    'gift_card_balance': '@integer(0, 500)', // 礼品卡余额，单位为分
    'retreat_amount': '@integer(0, 500)', // 退回金额，单位为分
    'reason': '@cword(20)', // 退回原因
    'is_expired': '@boolean()', // 是否超时，true or false
    'status': {
      'key': '@integer()', // 状态值
      'name': '已超时' // 状态名
    }
  }
}
)

// 礼品卡发记录的放客户信息 /gift_card/customer_info
Mock.mock(/gift_card\/customer_info/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'OK',
  'data': {
    'customer': 'superman',
    'customer_mobile': '13288888888',
    'plate_numbers': [
      '粤B12345',
      '粤C12346'
    ]
  }
})
